const spacer = {
  general: '4px 8px',
  bigger: '8px 16px',
  p4: '4px',
  p8: '8px',
  p16: '16px',
  p32: '32px',
  m4: '4px',
  m8: '8px',
  m16: '16px',
  m32: '32px',
}

export default spacer;